import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdminUserMangement } from "@root/services/admin/userManagement";
import { prepareErrorResponse } from "@root/services/http/response";
import { ADMIN_CREATE_USER_ACTION, ADMIN_USERS_MANAGEMENT_ACTION, GET_ADMIN_USER_BY_ID_ACTION } from "@root/store/action-types/admin/userManagement";
import { getBaseUrl } from "@root/store/selectors/features";

const adminUserMangement = new AdminUserMangement();

export const fetchAdminUsers: any = createAsyncThunk(
    ADMIN_USERS_MANAGEMENT_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;
        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminUserMangement.fetchAdminUsers(baseUrl, payload);
            onSuccess(result?.data?.data?.count);
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch (error) {
            onError(error);
            const customError = prepareErrorResponse(error)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);


export const addUser: any = createAsyncThunk(
    ADMIN_CREATE_USER_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;
        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminUserMangement.AddUser(baseUrl, payload);
            onSuccess(result?.data?.data);
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch (error) {
            onError(error);
            const customError = prepareErrorResponse(error)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);

export const fetchAdminUserByID: any = createAsyncThunk(
    GET_ADMIN_USER_BY_ID_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminUserMangement.fetchAdminUserByID(baseUrl, payload);
            onSuccess(result?.data?.data);
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch (error) {
            onError(error);
            const customError = prepareErrorResponse(error)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);
export const adminCreateUser: any = createAsyncThunk(
    ADMIN_CREATE_USER_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminUserMangement.createUser(baseUrl, payload);
            if (onSuccess) {
                onSuccess(result?.data?.data);
            }
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch (error) {
            if (onError) {
                onError(error);
            }
            const customError = prepareErrorResponse(error)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);